import { useState } from 'react'
import styles from './styles/profile-header.module.scss'
import Avatar from 'components/profile/Avatar'
import { MOBILE_BREAKPOINT } from 'constants/global'
import useViewport from 'hooks/use-viewport'
import { MIN_AGE_FOR_AVATAR_UPLOAD } from 'constants/profile'
import SelectAvatarModal from 'components/account/SelectAvatarModal'
import { ReactComponent as IconCamera } from 'images/icons/icn_camera.svg'
import moment from 'moment'
import WTNSpinner from 'components/generic/WTNSpinner'


interface Props {
  loadedAvatar?: string | null
  newAvatarLoading?: boolean
  userBirthDate?: string
  appElement: string
  onModalUploadFile: (file: File) => void
  onModalUpdateAvatar: (avatarUrl: string) => void
  currentAvatarUrl: string | null
}

const EditableAvatar = ({ loadedAvatar, newAvatarLoading, userBirthDate, appElement, onModalUploadFile, onModalUpdateAvatar, currentAvatarUrl }: Props) => {

  const [showSelectAvatarModal, setShowSelectAvatarModal] = useState(false)

  const isAvatarUploadDisabled = userBirthDate
    ? moment().diff(userBirthDate, 'years') < MIN_AGE_FOR_AVATAR_UPLOAD
    : true

  const { deviceWidth } = useViewport()

  return (
    <>
        {newAvatarLoading ? (
            <div className={styles.avatarLoadingWrapper}>
                <WTNSpinner width={80} />
            </div>
        ) : (
            <>
            <div
                role={'button'}
                className={styles.avatarWrapper}
                onClick={() => setShowSelectAvatarModal(true)}
            >
                <div className={styles.avatarOverlay}>
                <IconCamera className={styles.iconCamera} />
                </div>
                <Avatar 
                url={loadedAvatar || undefined}
                size={deviceWidth < MOBILE_BREAKPOINT ? 'md' : 'lg'}
                classWrapper={loadedAvatar ? styles.avatar : styles.avatarFallback}
                />
            </div>
            <SelectAvatarModal
                appElement={appElement}
                show={showSelectAvatarModal}
                onClose={() => setShowSelectAvatarModal(false)}
                uploadDisabled={isAvatarUploadDisabled}
                onUploadFile={onModalUploadFile}
                onUpdateAvatar={onModalUpdateAvatar}
                currentAvatarUrl={currentAvatarUrl}
            />
            </>
        )}              
    </>
  )
}

export default EditableAvatar
